import { FeedbackMetadataKeyValues } from '@modules/feedback/components/FeedbackCard/FeedbackMetadataKeyValues';
import { trackFeedbackEvents } from '@modules/feedback/utils';
import { Button, Grid, Paper, Stack } from '@mui/material';
import dayjs from 'dayjs';
import { Dispatch, SetStateAction } from 'react';
import { DATE_FORMAT } from 'v2/core/date/date';
import { Feedback } from 'v2/core/entities/feedback';

interface FeedbackDetailsCommonMetadataProps {
  feedback: Feedback;
  showOriginalLanguage: boolean;
  setShowOriginalLanguage: Dispatch<SetStateAction<boolean>>;
}

export const FeedbackDetailsCommonMetadata = ({
  feedback,
  setShowOriginalLanguage,
  showOriginalLanguage,
}: FeedbackDetailsCommonMetadataProps) => {
  const {
    language: { name: languageName },
    content: { isTranslated: showOriginalLanguageButton },
    sourceCreatedAt,
  } = feedback;

  const toggleShowOriginalLanguage = () => {
    setShowOriginalLanguage(!showOriginalLanguage);
    trackFeedbackEvents({
      eventName: 'Feedback Translation Changed',
      feedbackID: feedback.id,
    });
  };

  return (
    <Paper
      variant="outlined"
      sx={{
        py: 2,
        px: 3,
        borderRadius: 2,
      }}
    >
      <Grid container spacing={4} columns={showOriginalLanguageButton ? 1 : 2}>
        <Grid item md={1}>
          <Stack direction="row" alignItems="center" columnGap={3}>
            <FeedbackMetadataKeyValues
              displayName="Language"
              values={[languageName]}
              feedbackID={feedback.id}
            />
            {showOriginalLanguageButton && (
              <Button variant="outlined" onClick={toggleShowOriginalLanguage}>
                {showOriginalLanguage ? 'Show English' : `Show ${languageName}`}
              </Button>
            )}
          </Stack>
        </Grid>
        <Grid item md={1}>
          <FeedbackMetadataKeyValues
            displayName="Created At"
            values={[dayjs(sourceCreatedAt).tz().format(DATE_FORMAT)]}
            feedbackID={feedback.id}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
